import * as React from 'react';
import { Container, TituloSecao } from './styles';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import userContext from '../../Context/UserContext';
import { useContext } from 'react';
import { FormatarUrlName } from '../../helpers/valores';

const Categoria: React.FC = () => {
  const { id, name }: any = useParams();
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;
  const nomeFormatado = FormatarUrlName(decodeURIComponent(name));

  return (
    <Container>
      <TituloSecao>
        Categoria {id} - {nomeFormatado}
      </TituloSecao>
      <Grid Titulo={"Categoria" + nomeFormatado} Categoria={id} Codcliente={Codcliente} Codempresacli={Codempresacli} />
    </Container>
  )
};

export default Categoria;
